(function() {
	'use strict';

	angular.module('exportWarehouseApp').controller('StockOutBranchController',
			StockOutBranchController);

	StockOutBranchController.$inject = [ '$scope', '$filter', 'NgTableParams',
			'FORMAT_DATE', 'StockOutBranchService', '$uibModal', '$base64',
			'$window', '$stateParams', '$state', 'EVENT' ];

	function StockOutBranchController($scope, $filter, NgTableParams,
			FORMAT_DATE, StockOutBranchService, $uibModal, $base64, $window,
			$stateParams, $state, EVENT) {
		var vm = this;
		var self = $scope;
		$scope.format = 'dd/MM/yyyy';
		vm.popupCreateDate = false;
		var parent = $scope.$parent;

		$scope.dateOptionsOut = {
			minDate : new Date()
		};

		$scope.dateOptions = {
			minDate : new Date(1950, 1, 1),
			maxDate : new Date
		};

		vm.altInputFormats = [ 'M!/d!/yyyy' ];
		vm.warehouse = {
			status : 'ALL'
		};
		/*vm.warehouse.wareHouseName = parent.appCtrl.account.currentOffice.officeCode
				+ ' - ' + parent.appCtrl.account.currentOffice.officeName;
		vm.warehouse.wareHouseCode = parent.appCtrl.account.currentOffice.officeCode;*/

		$scope.$on(EVENT.changeOffice, function(event, args) {
			if (event.name = 'CHANGE_OFFICE') {
				$state.go($state.current, {}, {
					reload : true
				});
			}
		});

		vm.warehouse.requestDate = new Date();
		vm.param = {};

		vm.wareHouseTable = new NgTableParams({
			page : 1,
			count : 20
		}, {
			total : 0,
			counts : [],
			defaultSort : 'desc',
			getData : function(params) {
				vm.param.uri = "getListStockOutForBranch";
				vm.param.page = params.page();
				vm.param.size = params.count();
				vm.param.sort = params.sorting();
				vm.param.stockOutCode = vm.warehouse.stockOutCode;
				vm.param.status = vm.warehouse.status;
				if (vm.warehouse.createDate != null
						&& vm.warehouse.createDate != '') {
					vm.param.createDate = new Date(vm.warehouse.createDate);
				} else {
					vm.param.createDate = null;
				}
				vm.param.officeCode = parent.appCtrl.account.currentOffice.officeCode;
				/*if (vm.warehouse.wareHouseCode != undefined
						&& vm.warehouse.wareHouseCode != null) {*/
					self.loading = true;
					return StockOutBranchService.get(vm.param).$promise.then(
							function(result) {
								self.loading = false;
								params.total(result.totalElements);
								return result.content;
							}, function(error) {
								self.loading = false;
							});
//				}
			}
		});

		vm.search = function() {
			vm.wareHouseTable.page(1);
			vm.wareHouseTable.count(20);
			vm.wareHouseTable.total(0);
			vm.wareHouseTable.reload();
		};

		vm.openDatePicker = function() {
			vm.popupCreateDate = true;
		};

		vm.openPopup = function(stockOutId, typeProcess) {
			var link = GLOBAL_URL + 'stockout/#/createStockOutForBranch' + '/'
					+ $base64.encode(typeProcess);
			if (stockOutId !== null) {
				link = link + '/' + $base64.encode(stockOutId);
			}
			$window.open(link, '_self');
		};

		vm.isCreate = false;
		vm.isView = false;
		vm.isAdjust = false;
		vm.isExit = false;

		vm.initPage = function() {
			vm.warehouse.createDate = new Date();
			vm.warehouse.createUser = parent.appCtrl.account.fullName;
			vm.warehouse.departmentRequest = parent.appCtrl.account.department;
			var typeProcess = $base64.decode($stateParams.typeProcess);
			if ($stateParams.stockOutId != null) {
				vm.warehouse.stockOutId = $base64
						.decode($stateParams.stockOutId);
			}
			for (var i = 0; i < listTypeProcessHO.length; i++) {
				if (typeProcess == listTypeProcessHO[i].code) {
					vm.title = listTypeProcessHO[i].name;
					if (i == 0) { // create
						vm.isCreate = true;
						vm.isView = false;
						vm.isAdjust = false;
						vm.isExit = false;
					} else if (i == 1) { // view
						vm.isCreate = false;
						vm.isView = true;
						vm.isAdjust = false;
						vm.isExit = false;
					} else if (i == 2) { // adjust
						vm.isCreate = false;
						vm.isView = false;
						vm.isAdjust = true;
						vm.isExit = false;
					} else if (i == 3) { // exit
						vm.isCreate = false;
						vm.isView = false;
						vm.isAdjust = false;
						vm.isExit = true;
					}
					break;
				}
			}
			vm.getListStock(2);
		};

		vm.exit = function() {
			$state.go('stockOutForBranch');
		};

		vm.wareHouseInputTable = new NgTableParams(
				{
					page : 1,
					count : 20
				},
				{
					total : 0,
					counts : [],
					defaultSort : 'desc',
					getData : function(params) {
						vm.param.uri = "getListStockOutProductForBranch";
						vm.param.page = params.page();
						vm.param.size = params.count();
						vm.param.sort = params.sorting();
						vm.param.wareHouseCode = vm.warehouse.wareHouseCode;
						vm.param.stockOutId = vm.warehouse.stockOutId;

						if (vm.warehouse.wareHouseCode != null
								&& vm.warehouse.wareHouseCode != '') {
							self.loading = true;
							return StockOutBranchService.query(vm.param).$promise
									.then(function(result) {
										self.loading = false;
										vm.listProductImport = result;
										if (vm.listProductImport.length > 0
												&& !vm.isCreate) {
											vm.warehouse.tranferHOCode = vm.listProductImport[0].stockOutCode;
											vm.warehouse.createDate = new Date(
													vm.listProductImport[0].createdDate);
											vm.warehouse.requestDate = new Date(
													vm.listProductImport[0].shippingDate);
											vm.warehouse.cancelReason = vm.listProductImport[0].cancelReason;
											if (vm.listProductImport[0].cancelReason != null
													&& vm.listProductImport[0].cancelReason != '') {
												vm.showCancelReason = true;
											}
										}
										return result;
									}, function() {
										self.loading = false;
									});
						}
					}
				});

		vm.save = function() {
			self.loading = true;

			StockOutBranchService.post({
				uri : 'saveStockOut',
				stockRequestCode : vm.warehouse.wareHouseCode,
				shippingDate : vm.warehouse.requestDate
			}, vm.listExport, function(result) {
				$(window).scrollTop(0);
				self.loading = false;
				if (result.messages.length == 0) {
					self.addAlert('Thao tác thành công!', 'success');
					vm.exit();
				}
			}, function(error) {
				if(error.status == '403') {
					$scope.addAlert('Văn phòng không được thao tác chức năng này .Vui lòng chọn văn phòng khác!','error');
				}
				self.loading = false;
			});

		};

		vm.cancel = function() {
			StockOutBranchService
					.returnValue(
							{
								uri : 'cancelStockOut',
								cancelReason : vm.warehouse.cancelReason,
								stockOutId : vm.warehouse.stockOutId
							},
							function(result) {
								$(window).scrollTop(0);
								self.loading = false;
								if (result.response == -1) {
									self
											.addAlert(
													'Phiếu xuất kho này không thể hủy do đã được nhập kho!',
													'danger');
								} else if (result.response == -2) {
									self
									.addAlert(
											'Không được quyền hủy phiếu xuất kho của user khác!',
											'danger');
								} else {
									self.addAlert('Thao tác thành công!',
											'success');
								}
								vm.exit();
							}, function() {
								self.loading = false;
							});
		};

		vm.generalStockOut = function() {
			vm.wareHouseInputTable.page(1);
			vm.wareHouseInputTable.count(20);
			vm.wareHouseInputTable.total(0);
			vm.wareHouseInputTable.reload();
			
			vm.exportToExcel();
		};

		vm.exportToExcel = function() {
			if (vm.warehouse.wareHouseCode != undefined
					&& vm.warehouse.wareHouseCode != null) {
				self.loading = true;
				StockOutBranchService.query({
					uri : 'exportToExcel',
					wareHouseCode : vm.warehouse.wareHouseCode,
					stockOutId : vm.warehouse.stockOutId
				}, function(result) {
					vm.listExport = result;
					self.loading = false;
				}, function() {
					self.loading = false;
				})
			}
		};
		
		vm.getExportInfoDetail = function() {
			if(vm.warehouse.stockOutId != null && vm.warehouse.stockOutId != '') {
				self.loading = true;
				StockOutBranchService.get({
					uri : 'getExportInfoDetail',
					stockOutId : vm.warehouse.stockOutId
				}, function(result) {
					vm.warehouse.tranferHOCode = result.tranferHOCode;
					vm.warehouse.createDate = new Date(result.createDate);
					vm.warehouse.createUser = result.createUser;
//					vm.warehouse.wareHouseName = result.wareHouseCode + ' - ' + result.wareHouseName
					vm.warehouse.wareHouseCode = result.wareHouseCode;
					vm.warehouse.cancelReason = result.cancelReason;
					if(result.cancelReason != null && result.cancelReason != '') {
						vm.showCancelReason = true;
					}
					vm.warehouse.requestDate = new Date(result.requestDate);
					vm.warehouse.owner = result.owner;
					self.loading = false;
				}, function() {
					self.loading = false;
				}).$promise.then(function(result) {
					vm.wareHouseInputTable.page(1);
					vm.wareHouseInputTable.count(20);
					vm.wareHouseInputTable.total(0);
					vm.wareHouseInputTable.reload();
					self.loading = false;
				});
			} else {
				vm.generalStockOut();
			}
		};
		
		vm.getListStock = function(typeView) {
			StockOutBranchService
					.query(
							{
								uri : 'getListStock',
								type : '1',
								officeCode : parent.appCtrl.account.currentOffice.officeCode
							},
							function(result) {
								vm.warehouse.listWarehouse = result;
								if(result.length > 0) {
									vm.warehouse.wareHouseCode = result[0].code;
								} else {
									self.addAlert('Văn phòng này không được phép thao tác chức năng này', 'danger');
								}
							}).$promise.then(function(
									result) {
								if(typeView == 1) {
									vm.search();
//									vm.wareHouseTable.reload();
								} else if(typeView == 2) {
//									vm.getListRequestTranfer();
									vm.getExportInfoDetail();
									vm.exportToExcel();
//									vm.generalStockOut();
								}
							});
		};
		
		vm.init = function() {
			vm.getListStock(1);
		};
	}
})();
